import React from 'react';
import { motion } from 'framer-motion';
export function CultureSection() {
  return <section id="culture" className="py-[80px] sm:py-[100px] md:py-[120px] px-5 sm:px-6 md:px-[48px] bg-[#1a1a1a] border-b border-tux-border relative overflow-hidden" data-id="element-31">
      {/* Radial Gradient Background */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 60% 60% at 50% 50%, rgba(200,255,0,0.025) 0%, transparent 70%)'
    }} data-id="element-32" />

      <div className="max-w-[1200px] relative z-10" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-34">
          {/* Section Label */}
          <div className="font-mono font-light text-[9px] tracking-[0.36em] uppercase text-tux-muted flex items-center gap-[16px] mb-[28px] sm:mb-[40px]" data-id="element-35">
            Culture
            <div className="flex-1 h-[1px] bg-tux-border" data-id="element-36" />
          </div>

          <h2 className="font-display font-black text-[clamp(44px,7.5vw,100px)] uppercase leading-[0.9] tracking-[-0.01em] text-white mb-[32px] sm:mb-[44px]" data-id="element-37">
            First Impressions.
            <br data-id="element-38" />
            <span className="text-tux-lime" data-id="element-39">Before The Market.</span>
          </h2>

          <div className="font-sans font-light text-[15px] sm:text-[18px] leading-[1.75] text-white/40 max-w-[540px]" data-id="element-40">
            Everything we build is designed with intention and built to perform.
          </div>
        </motion.div>
      </div>
    </section>;
}